import classNames from "classnames";
import {forwardRef} from "react";

import {SwitchProps} from "@/components/switch/Switch.types.ts";
import {SwitchInput} from "@/components/switch/SwitchInput/SwitchInput.tsx";
import {SwitchLabel} from "@/components/switch/SwitchLabel/SwitchLabel.tsx";

import styles from "./Switch.module.scss";

const SwitchComponent = forwardRef<HTMLInputElement, SwitchProps>(
  (
    {
      className,
      children,
      id,
      label,
      description,
      disabled,
      helpText,
      labelPosition = "right",
      labelTypography,
      required,
      ...rest
    },
    ref
  ) => {
    const labelElement = (label || description) && (
      <SwitchLabel
        forId={id!}
        helpText={helpText}
        description={description}
        disabled={disabled}
        labelTypography={labelTypography}
        required={required}
      >
        {label}
      </SwitchLabel>
    );

    return (
      <div className={classNames("form-switch", styles.switchRoot, className)}>
        {children || (
          <>
            {labelPosition === "left" && labelElement}
            <SwitchInput id={id!} disabled={disabled} ref={ref} {...rest} />
            {labelPosition === "right" && labelElement}
          </>
        )}
      </div>
    );
  }
);

SwitchComponent.displayName = "Switch";

export const Switch = Object.assign(SwitchComponent, {
  Input: SwitchInput,
  Label: SwitchLabel,
});
